<template>
  <div class="calendar-box">
    <div class="week-item" :class="[isCurrentWeek(weeks[index]) ? 'current' : '', chooseIndex == index ? 'choose' : '']" v-for="(item, index) in getWeeks" :key="index" @click="clickDate(index)" >
      <div class="week" :class="[chooseIndex == index ? 'choose' : '']">第{{ index + 1 }}周</div>
      <div>{{ item.mon }}-{{ item.sun }}</div>
      <div class="point" :style="{backgroundColor: getStatusColor(weeks[index])}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    year: {
      type: String,
      default: new Date().getFullYear().toString(),
    },
    month: {
      type: String,
      default: new Date().getMonth().toString(),
    },
    startDay: {
      type: String,
      default: '',
    },
    endDay: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      weeks: [],
      chooseIndex: 0
    }
  },
  computed: {
    isCurrentWeek() {
      return item => {
        let now = new Date()
        let dayTime = 24 * 3600 * 1000
        let nowWeek = new Date(now.getTime() - (now.getDay() - 1) * dayTime ).format('yyyy-MM-dd') + '~' + new Date(now.getTime() + (7 - now.getDay()) * dayTime).format('yyyy-MM-dd')
        if (nowWeek == item) {
          return true
        }
        return false
      }
    },
    getWeeks() {
      this.weeks = []
      let weekList = []
      let first = new Date(this.year, this.month, 1) // 当月第一天
      let nowWeek
      let firDay //扣减天数，如当月第一天为1号，需从1号开始
      if (first.getDay() != 1 && first.getDay() != 0) {
        nowWeek = 7 - first.getDay() + 2
        firDay = 0
      }else if(first.getDay() == 0){
        nowWeek = 7 - 7 + 2
        firDay = 7
      } else {
        nowWeek = 1
        firDay = 7
      }
      let num = Math.ceil((new Date(this.year, parseInt(this.month) + 1 , 0).getDate() - nowWeek + 1) / 7) // 周一的次数
      let dayTime = 24 * 3600 * 1000
      let weekTime = 7 * 24 * 3600 * 1000
      for (let i = 0; i < num; i++) {
        let mon = new Date(first.getTime() + (7 - first.getDay() - firDay + 1) * dayTime + i * weekTime)
        let sun = new Date(first.getTime() + (7 - first.getDay() - firDay + 1) * dayTime + weekTime + i * weekTime - dayTime)
        weekList.push({
          mon: mon.format('M.dd'),
          sun: sun.format('M.dd'),
        })
        this.weeks.push(mon.format('yyyy-MM-dd') + '~' + sun.format('yyyy-MM-dd'))
      }
      return weekList
    },
     getStatusColor() {
      return item => {
        let index = this.list.findIndex(child => child.date == item)
        let starTme = item.split('~')[0]
        let endTme = item.split('~')[1] 
        if (index != -1) {
          if(this.startDay!=''){
            if(new Date(starTme).getTime()<new Date(this.startDay).getTime()){
              return '#f2f2f4'
            }
          }
          if(this.endDay!=''){
            if(new Date(endTme).getTime()>new Date(this.endDay).getTime()){
              return '#f2f2f4'
            }
          }
          if (this.list[index].hasData) {
            var xxdm = sessionStorage.getItem("schoolCode");
            if(xxdm == '14475'){
              if (this.list[index].status == '2') {
                return '#41B29C'
              }else if (this.list[index].status == '3') {
                return '#ee0a24'
              } else {
                return '#0189F9'
              }
            }else{
              if (this.list[index].status == '2') {
                return '#41B29C'
              }else {
                return '#0189F9'
              }
            }
            
          }
        }
        //#f2f2f4
        return '#FE923F'
      }
    },
  },
  methods: {
    clickDate(index){
      let date = new Date(this.weeks[index].split('~')[0]).getTime()
      let now = new Date().getTime()
      if(date > now){
        return
      }
      if(this.startDay!='' && date<new Date(this.startDay).getTime()){
        return
      }
      this.chooseIndex = index
      this.$emit('dateClick', this.weeks[index])
    }
  },
  created() {},
}
</script>

<style lang="less" scoped>
.calendar-box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}
.week-item {
  position: relative;
  width: 75px;
  height: 50px;
  background: #f2f2f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 10px;
  color: #999999;
  text-align: center;
  .week {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    text-align: center;
  }
  .point {
    position: absolute;
    width: 4px;
    height: 4px;
    background: #0189f9;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    bottom: 2px;
  }
}
.current {
  background: #deeefd;
}
.choose {
  background: #0189f9;
  color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/calendarWeek.vue